import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, Modal, Row, Space, Form, Radio } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 }
}

interface Prop {
    storeID?: string
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()

    const [form] = useForm()
    const [isSuccess, setIsSuccess] = useState<number>(0)

    useEffect(() => {
        getClientInfo()
    }, [])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }
        })
    }

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/check_out_follow', {
            check_in_id: param.id,
            follow_time: form.getFieldValue('follow_time').format('YYYY-MM-DD'), // 跟进时间
            contact_success: form.getFieldValue('contact_success'), // 是否联系成功，0否 1是，整数类型
            follow_content: form.getFieldValue('follow_content'), // 跟进内容

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 跟进出所客户 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>跟进出所客户</Button>

        <Modal title="跟进出所客户" width={800} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={8}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期：</p>
                            <p>{clientData?.expect_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={8}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                {/* <Col span={6}>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                </Col> */}

                <Col span={8}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <div>
                <Form form={form} {...formItemLayout} style={{ marginTop: 20 }}>
                    <Form.Item label="跟进日期" name="follow_time">
                        <DatePicker />
                    </Form.Item>

                    <Form.Item label="是否联系成功" name="contact_success">
                        <Radio.Group onChange={(v: any) => {
                            setIsSuccess(v.target.value)
                        }}>
                            <Radio value={0}>否</Radio>
                            <Radio value={1}>是</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {isSuccess !== 0 && <Form.Item label="跟进内容" name="follow_content">
                        <Input />
                    </Form.Item>}
                </Form>
            </div>
        </Modal>
    </Fragment>
}